import {createContext} from 'react';

export interface IResizeContext {
    setResizeHandler(enabled: boolean, pos: { left: number, width: number, colKey: string; }): void;
}

export default createContext<IResizeContext>({
    setResizeHandler: null
});
